import * as SITE_ACTION_TYPES from '../site/actionTypes';

import { SiteActions, ISiteState } from './types';

const initialState: ISiteState = {
  total: 0,
  siteList: [],
  loading: false,
  error: null,
  accountList: [],
  accountDropdownLoading: true,
  countyList: [],
  countyDropdownLoading: true,
  operatingUnitList: [],
  operatingUnitDropdownLoading: false,
  detail: {
    id: 0,
    name: '',
    city: '',
    phoneNumber: '',
    tenantId: 0,
    userId: null
  },
  nudgeStatus: {
    showNudge: false,
    loading: false,
    error: null
  }
};

const siteReducer = (state: ISiteState = initialState, action: SiteActions) => {
  switch (action.type) {
    case SITE_ACTION_TYPES.FETCH_SITE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        total: action.payload.total || 0,
        siteList: action.payload.sites || []
      };
    case SITE_ACTION_TYPES.FETCH_SITE_LIST_REQUEST:
      return {
        ...state,
        loading: true
      };
    case SITE_ACTION_TYPES.FETCH_SITE_LIST_FAILURE:
      return {
        ...state,
        loading: false
      };
    case SITE_ACTION_TYPES.SET_SITE_DETAIL:
      return {
        ...state,
        detail: {
          ...state.detail,
          ...action.payload
        }
      };
    case SITE_ACTION_TYPES.CLEAR_SITE_DETAIL:
      return {
        ...state,
        detail: initialState.detail
      };
    case SITE_ACTION_TYPES.FETCH_NUDGE_STATUS_REQUEST:
      return {
        ...state,
        nudgeStatus: {
          ...state.nudgeStatus,
          loading: true,
          error: null
        }
      };
    case SITE_ACTION_TYPES.FETCH_NUDGE_STATUS_SUCCESS:
      return {
        ...state,
        nudgeStatus: {
          ...action.payload,
          loading: false,
          error: null
        }
      };
    case SITE_ACTION_TYPES.FETCH_NUDGE_STATUS_FAILURE:
      return {
        ...state,
        nudgeStatus: {
          ...state.nudgeStatus,
          loading: false,
          error: action.error
        }
      };
    case SITE_ACTION_TYPES.CLOSE_NUDGE:
      return {
        ...state,
        nudgeStatus: {
          ...state.nudgeStatus,
          showNudge: false
        }
      };
    default:
      return state;
  }
};

export default siteReducer;
